import { Pipe, PipeTransform } from '@angular/core';
import { DashboardDevice, DashboardMainDevice, SubscriptionPlan } from '@vi-iot/client';

@Pipe({
  name: 'highestSubscriptionPlan',
  standalone: true,
})
export class HighestSubscriptionPlanPipe implements PipeTransform {
  transform(device: DashboardDevice | DashboardMainDevice): SubscriptionPlan | undefined {
    return HighestSubscriptionPlanPipe.getHighestDevicePlan(device);
  }

  // Standalone pipes cannot be imported by serviced
  // https://stackoverflow.com/questions/75201500/is-it-possible-to-use-pipe-in-typescript-component-or-service-class
  // transform() is used by components, static method by services
  // I find this less misleading than wrapping in module which could eventually result in error
  static getHighestDevicePlan(
    device: DashboardDevice | DashboardMainDevice
  ): SubscriptionPlan | undefined {
    let pro = false;
    let plus = false;
    let basic = false;
    let free = false;

    if (!device?.plans) {
      return;
    }

    device.plans.forEach((plan) => {
      switch (plan) {
        // Dashboard doesn't get trial information
        case SubscriptionPlan.Pro:
          pro = true;
          break;
        case SubscriptionPlan.Plus:
          plus = true;
          break;
        case SubscriptionPlan.Basic:
          basic = true;
          break;
        case SubscriptionPlan.Free:
          free = true;
          break;
      }
    });

    if (pro) {
      return SubscriptionPlan.Pro;
    }
    if (plus) {
      return SubscriptionPlan.Plus;
    }
    if (basic) {
      return SubscriptionPlan.Basic;
    }
    if (free) {
      return SubscriptionPlan.Free;
    }
  }
}
